// ============================================================================
// COCKTAIL SHAKER SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'cocktail-shaker-sort',
  name: 'Cocktail Shaker Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²) average/worst, O(n) best',
    space: 'O(1)'
  },
  description: 'Cocktail Shaker Sort is a bidirectional variation of bubble sort that alternates between forward and backward passes, moving larger elements to the end and smaller elements to the beginning.'
};
export type MetaType = typeof meta;
